// DataTable.tsx

import React from 'react'
import { AutoSizer, Column, Table, TableCellDataGetter, TableCellRenderer } from 'react-virtualized'

import DataTableHeader from './DataTableHeader'
import DataTableRow from './DataTableRow'

export interface IColumnItemsProps {
  cellDataGetter?: TableCellDataGetter
  cellRenderer?: TableCellRenderer
  dataKey: string
  label: string
  width: number
}

export interface IDataTableProps {
  columns: IColumnItemsProps[]
  items: any[]
}

export default function DataTable({ items, columns }: IDataTableProps) {
  const rowGetter = ({ index }: { index: number }) => {
    return items[index] ?? {}
  }

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Table
          width={width}
          height={height}
          headerHeight={50}
          rowHeight={42}
          rowCount={items.length}
          headerRowRenderer={DataTableHeader}
          rowRenderer={DataTableRow}
          rowGetter={rowGetter}
        >
          {columns.map((c) => (
            <Column key={c.dataKey} {...c} />
          ))}
        </Table>
      )}
    </AutoSizer>
  )
}
